import { Component } from '@angular/core';

@Component({
    selector: 'app-notfound',
    templateUrl: './notfound.component.html',
    styleUrls: [],
})
export class NotfoundComponent {
}
